exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".warning-label{display:-ms-flexbox;display:flex;-ms-flex-pack:start;justify-content:flex-start;border-radius:5px;padding:10px;margin-bottom:.5rem}.warning-label.warning{background-color:rgba(255,238,177,.25);border:1px solid #ffeeb1}.warning-label.danger{background-color:rgba(255,177,177,.25);border:1px solid #ffb1b1}.warning-label .icon{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-preferred-size:20px;flex-basis:20px;margin:0 10px}.warning-label .icon i{font-size:1.5rem;line-height:1.5rem}.warning-label .label{-ms-flex:1 1 0px;flex:1 1 0}.warning-label .label .identifier{margin-right:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--1-2!./node_modules/sass-loader/dist/cjs.js??ref--1-3!./src/invoice/components/WarningLabel/WarningLabel.scss
// module id = 4361
// module chunks = 0